/* eslint-disable camelcase */
import './shared'
import React from 'react'

import locale from 'live/init/global-locale'
import LiveAPI from 'live/lib/api'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'
import serviceLocator from 'live/services/service-locator'
import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { overviewDisplayAPI } from 'plugin-codaf-risk-ext-bowtie/shared/api'
import { IUpdateModeFrontPresenter, updateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'

import { BowtieAlarmsWrapper } from './BowtieAlarms'
import { BowtieAlarmsNotificationSettingsWrapper } from './BowtieAlarmsNotificationSettings'
import { BowtieBarrierSettingsWrapper } from './BowtieBarrierSettings'
import { BowtieManagementWrapper } from './BowtieManagment'
import { BowtieManagementConfigs } from './BowtieManagment/BowtieManagementConfigs'
import { AssetSelector } from './BowtieManagment/components/AssetSelector'
import { BowtieReportsWrapper } from './BowtieReports'
import { BowtieSettingsWrapper } from './BowtieSettings'
import { EngineeringAuditWrapper } from './EngineeringAudit'
import { en_us, pt_br } from './i18n'
import { reducer } from './reducer'
import { ChartState, ChartMessage, Configs } from './types/batchEvent'
import {
    BOWTIE_SETTINGS_URL,
    BOWTIE_BARRIER_SETTINGS,
    DRA_REPORTS,
    DRA_ALARMS,
    DRA_ALARM_SETTINGS,
    ENGINEERING_AUDIT,
    zoomLevel0,
    zoomLevel1,
    zoomLevel2
} from './utils/constants'

const localeFiles = { pt_br, en_us }

try {
    i18n.add(localeFiles[locale])
} catch (error) {
    console.log(error)
}

const alarmAdmin = authorization.superAdmin || authorization.Permission.DRA_ALARMS
const draAdminAndSuperAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN
const draPermission =
    authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN || authorization.Permission.BOWTIE_MANAGER

/**
 * DRA start process occur in another thread and live is not prepared to this feature.
 * In script orders the DRA script tag enter after the another plugin who require it.
 * Any "import {...} from 'plugin-codaf-risk-ext-bowtie/shared/...'" fails.
 * Service locator register solve this problem because any plugin who use the overviewDisplayAPI will be registered
 * as listener and when DRA finish initialization process it will register a provider of the api and all listeners
 * will receive the service and continue your initialization process.
 *
 * Service locator details: https://drive.google.com/file/d/1URzdJoDrUS8I1ljMCUMIOiH6yrCEMKHK/view?usp=sharing
 */
serviceLocator.registerService('dra:overview-service', overviewDisplayAPI)
serviceLocator.registerService('dra:updatemodefrontservice', updateModeFrontAPI)

/** used to register Bowtie Settings on configuration Tab */
/** CONFIGURE EDITOR **/
draPermission &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: 'Dynamic Risk Advisor',
            area: BOWTIE_SETTINGS_URL,
            component: BowtieSettingsWrapper,
            name: i18n('Editor')
        })
    })

draAdminAndSuperAdmin &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: i18n('Dynamic Risk Advisor'),
            area: BOWTIE_BARRIER_SETTINGS,
            component: BowtieBarrierSettingsWrapper,
            name: i18n('Settings')
        })
    })

serviceLocator.getService('live-ui:configuration-service').then(() => {
    LiveAPI.Extension.configuration.entries.register({
        group: i18n('Dynamic Risk Advisor'),
        area: DRA_REPORTS,
        component: BowtieReportsWrapper,
        name: i18n('Reports')
    })
})

alarmAdmin &&
    serviceLocator.getService('live-ui:configuration-service').then(() => {
        LiveAPI.Extension.configuration.entries.register({
            group: i18n('Dynamic Risk Advisor'),
            area: DRA_ALARMS,
            component: BowtieAlarmsWrapper,
            name: i18n('Alarm Group Configuration')
        })
    })

serviceLocator.getService('live-ui:configuration-service').then(() => {
    LiveAPI.Extension.configuration.entries.register({
        group: i18n('Dynamic Risk Advisor'),
        area: DRA_ALARM_SETTINGS,
        component: BowtieAlarmsNotificationSettingsWrapper,
        name: i18n('Alarms Notification Settings')
    })
})

/** END CONFIGURE EDITOR **/

serviceLocator.getService('live-ui:configuration-service').then(() => {
    LiveAPI.Extension.configuration.entries.register({
        group: i18n('Dynamic Risk Advisor'),
        area: ENGINEERING_AUDIT,
        component: EngineeringAuditWrapper,
        name: i18n('Engineering Audit')
    })
})

/* Register do overview default do bowtie */
overviewDisplayAPI.register({
    uid: 'default',
    name: i18n('Default overview'),
    hideDefaultResourcesToDisplaySelect: true,
    selectAllResourcesToDisplay: true,
    isDefault: true,
    hideOverviewSelector: true,
    element: AssetSelector
})

const widgetType = 'risk-management-bowtie'
widgetService.register({
    type: widgetType,
    name: 'Risk Management Bowtie',
    description: 'This chart is a part of the Risk Management Group',
    config: {
        overview: 'default',
        assets: null,
        customZoomLevels: {
            level0: zoomLevel0,
            level1: zoomLevel1,
            level2: zoomLevel2
        }
    },
    ui: {
        configForm: BowtieManagementConfigs
    },
    policies: {
        defaultReducer:
            'last(*) by __type, id, version at the end => @yield => @top 1, ts desc, version desc by id, __type',
        handleOwnMissingData: true,
        preventReloadOnParamsChange: true
    },
    impl: reactWidgetWrapper<ChartState, ChartMessage, Configs>(BowtieManagementWrapper, reducer)
})

// widgetService.config()
